import {inject, Injectable} from '@angular/core';
import {AuthService} from '../../authentication/auth-service';
import {ClaimManagerBackend} from '../../environments/application-configurations';
import {environment} from '../../environments/environment';
import {ClaimMetadataRequest} from '../entity/metadata';
import {ClaimFile, ClaimFileType, PresignedClaimFileUrlResponse} from '../entity/claim-file';
import {ClaimItem} from '../entity/claim-item';

@Injectable({
  providedIn: 'root'
})
export class ClaimCreatorService {
  private readonly authService: AuthService = inject(AuthService)
  private readonly backendConfig: ClaimManagerBackend = environment.claimManagerBackend

  public async createClaimDraft(parameters: ClaimMetadataRequest): Promise<ClaimItem> {
    const path = this.backendConfig.upsertClaimDraftPath

    const url = `${this.backendConfig.baseUrl}${path}`
    const headers = new Headers();
    headers.set('Authorization', `Bearer ${this.authService.getIdToken()}`);
    headers.set('Content-Type', 'application/json');

    return await fetch(
      url,
      {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(parameters)
      }
    ).then(async r => {
      return {
        response: r,
        payload: (await r.json())
      };
    }).then(r => {
      if (r.response.ok) {
        return r.payload
      }
      if (r.payload && r.payload['detail'] && r.payload['detail'].includes('already exists')) {
        throw new Error(`Error creating claim because ${r.payload['detail'].replaceAll('|', ', ').toLowerCase()}`)
      } else {
        throw new Error(`Error creating claim: ${r.response.statusText}`)
      }
    }) as ClaimItem
  }

  public async getPresignedUrls(claimId: string, claimFileType: ClaimFileType, parameters: ClaimFile[]): Promise<PresignedClaimFileUrlResponse> {
    const path = this.backendConfig.createPresignedUploadUrlsPath
      .replace("{claimId}", claimId)
      .replace("{claimFileType}", claimFileType)

    const url = `${this.backendConfig.baseUrl}${path}`
    const headers = new Headers();
    headers.set('Authorization', `Bearer ${this.authService.getIdToken()}`);
    headers.set('Content-Type', 'application/json');

    return await fetch(
      url,
      {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(parameters)
      }
    ).then(r => r.json()) as PresignedClaimFileUrlResponse
  }

  public async submitClaim(claimId: string, adjustmentMethod: string): Promise<void> {
    const path = this.backendConfig.submitClaimPath.replace("{claimId}", claimId)

    const queryParams = new URLSearchParams({
      adjustment_method: adjustmentMethod
    });
    const url = `${this.backendConfig.baseUrl}${path}?${queryParams.toString()}`
    const headers = new Headers();
    headers.set('Authorization', `Bearer ${this.authService.getIdToken()}`);
    headers.set('Content-Type', 'application/json');
    console.log(url)
    return await fetch(
      url,
      {
        method: 'PUT',
        headers: headers
      }
    ).then(r => console.log('claim submitted', url, r))
  }
}
